/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Laravel
 * OpenAPI spec version: 0.0.1
 */

export type AssessmentStatus = typeof AssessmentStatus[keyof typeof AssessmentStatus];


export const AssessmentStatus = {
  not_submitted: 'not_submitted',
  pending_review: 'pending_review',
  changes_requested: 'changes_requested',
  graded: 'graded',
  graded_with_retry: 'graded_with_retry',
} as const;
